import { render, staticRenderFns } from "./BankDocumentDetails.vue?vue&type=template&id=08e28b84&scoped=true&"
import script from "./BankDocumentDetails.vue?vue&type=script&lang=ts&"
export * from "./BankDocumentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BankDocumentDetails.vue?vue&type=style&index=0&id=08e28b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e28b84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
